module.exports = __webpack_public_path__ + "static/img/33.461507e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/33.png
// module id = UfZe
// module chunks = 0